import { useAuth } from "context/AuthContext";
import { useStore } from "context/GlobalContext";
import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  FaRedhat,
  FaCalendarAlt,
  FaHammer,
  FaDollarSign,
} from "react-icons/fa";
import {
  MdBackHand,
  MdRotate90DegreesCcw,
  MdWorkspacesOutline,
  MdLocationOn,
  MdOutlineCategory,
  MdMap,
  MdSave,
  MdCancel,
} from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Card from "components/Card";
import { useLocation, useNavigate } from "react-router-dom";
import caseLogService from "api/casesAPI";
import { format } from "date-fns";
import filesServices from "api/filesAPI";
import CaseFile from "components/CaseFile";
import UploadButton from "components/UploadButton";
import { Oval } from "react-loader-spinner";
const EditCase = () => {
  const { data } = useLocation().state;
  const [caseLog, setCasLog] = useState(data);
  const [caseFiles, setCaseFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    id,
    caseNumber,
    date,
    investigatorAssigned,
    incidentType,
    location,
    zone,
    category,
    loss,
    recovery,
    description,
    caseClosureComments,
    terminationOrWrittenWarning,
    png,
    status,
  } = caseLog;

  const [pickerDate, setPickerDate] = useState(new Date(date));
  const { user } = useAuth();

  const { incidentsTypes, categories, locations } = useStore();

  const router = useNavigate();

  const uploadFiles = async (files) => {
    console.log("Files length", files.length);
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("file", files[i]);
    }
    formData.append("caseId", id);
    formData.append("caseNumber", caseNumber);
    const result = await filesServices.add(formData);
    if (result.ok) {
      console.log("Files Uploaded", files);
      return;
    }
    console.log("File upload failed");
  };
  const handleSave = async () => {
    console.log(caseLog);

    const result = await caseLogService.edit(caseLog);
    if (result.ok) {
      uploadFiles(selectedFiles);
      const alertResult = Swal.fire({
        title: "Case Updated!",
        text: "Do you want to continue editing?",
        icon: "success",
        background: "#2b3445",
        color: "#fff",

        showDenyButton: true,

        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes !",
      });

      if ((await alertResult).isConfirmed) {
        return;
        // generateCaseNumber();
      } else {
        router("/case-log");
        return;
      }
    }

    Swal.fire({
      title: "Error",
      text: "An error occured while adding the case",
      icon: "error",
      background: "#2b3445",
      color: "#fff",

      confirmButtonColor: "#d33",

      confirmButtonText: "OK !",
    });
  };

  const getFiles = useCallback(async () => {
    setLoading(true);
    const result = await filesServices.getCaseFiles(caseLog.caseNumber);
    if (result.ok) {
      setCaseFiles(result.data);
    }
    setLoading(false);
  }, [caseLog.caseNumber]);
  useEffect(() => {
    getFiles();
  }, [getFiles]);
  return (
    <div className="flex flex-col text-sm flex-1  h-full ">
      {/* <button onClick={() => console.log(caseLog)}>Here</button> */}
      <div className="flex flex-col sm:flex-row items-center  sm:justify-between space-y-2 sm:space-y-0  ">
        <div className="text-xl bg-primary/40 w-full sm:w-fit h-fit px-2 rounded shadow-md">
          {/* UIS- */}
          <input
            value={caseNumber}
            onChange={(e) => {
              // setCaseNumber(e.target.value);
              setCasLog((prev) => ({
                ...prev,
                caseNumber: e.target.value,
              }));
            }}
            className="w-fit outline-none bg-transparent"
          />
        </div>

        <div className="flex items-center space-x-1 text-base bg-secondary rounded px-1 py-1 w-full sm:w-fit">
          <div className="flex space-x-2 items-center justify-between w-full">
            <div className="flex space-x-2">
              <FaRedhat className="w-6 h-6" />
              <span className="text-primary">Investigator</span>
            </div>
            <select
              value={investigatorAssigned}
              className=" bg-blue-500/70 hover:bg-secondary rounded px-2"
              onChange={(e) =>
                setCasLog((prev) => ({
                  ...prev,
                  investigatorAssigned: e.target.value,
                }))
              }
            >
              {investigatorAssigned === "" && (
                <option value={user.name}>{user.name}</option>
              )}
              <option value={"Alex Leek"}>{"Alex Leek"}</option>
              <option value={"Mark Bent"}>{"Mark Bent"}</option>
              <option value={"Rana Bojan"}>{"Rana Bojan"}</option>
              <option value={"Free"}>{"Free"}</option>
              <option value={investigatorAssigned}>
                {investigatorAssigned}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div className="flex my-3 px-2 space-x-5 self-center sm:self-start text-xl sm:text-sm">
        <div className="flex items-center space-x-1">
          <FaCalendarAlt />
          <span>Date</span>
          <DatePicker
            className="px-2   w-28 outline-none rounded bg-secondary"
            selected={pickerDate}
            onChange={(e) => {
              setPickerDate(e);
              setCasLog((prev) => ({
                ...prev,
                date: format(e, "M/d/yyyy"),
              }));
            }}
            dateFormat="d/M/yyyy"
          />
        </div>
      </div>

      <div className="flex sm:space-x-5 flex-col sm:flex-row items-center w-full">
        <div className="flex mb-3 mx-2 px-2 space-x-5 bg-secondary  py-1 rounded sm:w-fit w-full">
          <div className="flex items-center  justify-between w-full">
            <div className="flex space-x-1 items-center">
              <FaHammer />
              <span>Termination-Warning</span>
            </div>

            <input
              value={terminationOrWrittenWarning}
              placeholder="None"
              className=" outline-none bg-orange-900/70 px-2 py-1 ml-2 rounded"
              onChange={(e) =>
                setCasLog((prev) => ({
                  ...prev,
                  terminationOrWrittenWarning: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="flex mb-3 mx-2 px-2 sm:space-x-5 bg-secondary  py-1 rounded sm:w-fit w-full">
          <div className="flex items-center  justify-between w-full">
            <div className="flex items-center space-x-1">
              <MdBackHand />
              <span>PNG</span>
            </div>

            <input
              value={png}
              placeholder="None"
              className="outline-none bg-red-500/50 px-2 py-1 ml-2 rounded"
              onChange={(e) =>
                setCasLog((prev) => ({
                  ...prev,
                  png: e.target.value,
                }))
              }
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between h-full space-y-3 md:space-y-0 md:space-x-1 ">
        <div className=" w-full h-screen md:h-full flex flex-col space-y-3 sm:px-2 ">
          <div className="flex flex-col h-full shadow-lg ring-primary/60 rounded focus-within:ring-1 overflow-hidden">
            <label className=" bg-primary/20  px-2 py-1">Description</label>
            <textarea
              placeholder="Enter Description"
              className=" bg-sidebar rounded h-full py-1 px-2 resize-none outline-none "
              value={description}
              onChange={(e) =>
                setCasLog((prev) => ({ ...prev, description: e.target.value }))
              }
            />
          </div>
          <div className="flex flex-col h-full shadow-lg ring-primary/60 rounded focus-within:ring-1 overflow-hidden">
            <label className=" bg-gray-500/80  px-2 py-1">Case Closure</label>
            <textarea
              placeholder="Enter comments here if the case is closed"
              className=" bg-sidebar/30 rounded h-full py-1 px-2 resize-none outline-none  "
              value={caseClosureComments}
              onChange={(e) =>
                setCasLog((prev) => ({
                  ...prev,
                  caseClosureComments: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="flex md:w-[150px] break-words    ">
          <Card title={"Files"}>
            <div
              className={`md:flex md:flex-col md:h-full ${
                caseFiles.length === 0 && "text-center"
              }   md:justify-center grid grid-cols-3 gap-x-10 `}
            >
              {loading && (
                <div className=" flex flex-col  flex-1 w-full h-screen justify-center items-center space-y-5 ">
                  <Oval
                    height={60}
                    width={60}
                    color="royalblue"
                    secondaryColor="white"
                  />
                </div>
              )}
              {caseFiles.length > 0
                ? caseFiles.map((file) => (
                    <CaseFile
                      key={file.id}
                      fileName={file.fileName}
                      caseNumber={file.caseNumber}
                      caseId={file.id}
                      caseFiles={caseFiles}
                      setCaseFiles={setCaseFiles}
                      readOnly={true}
                    />
                  ))
                : loading
                ? null
                : "No files"}
            </div>
          </Card>
        </div>

        <div className="flex flex-col justify-between    ">
          <div className="flex flex-col space-y-2">
            <Card title={"Case Details"}>
              <div className="grid grid-cols-2     ">
                <div className="flex space-x-1 ">
                  <MdWorkspacesOutline className="w-4 h-4" />
                  <span>Inceident Type</span>
                </div>

                <select
                  value={incidentType}
                  className="bg-secondary px-1 rounded py-1"
                  onChange={(e) =>
                    setCasLog((prev) => ({
                      ...prev,
                      incidentType: e.target.value,
                    }))
                  }
                >
                  {incidentsTypes.map((type) => (
                    <option key={type.name} value={type.name}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="grid grid-cols-2   ">
                <div className="flex space-x-1 ">
                  <MdLocationOn className="w-4 h-4" />
                  <span>Location</span>
                </div>
                <input
                  value={location}
                  className="bg-secondary px-1 py-1 outline-none rounded"
                  placeholder="Enter location..."
                  onChange={(e) =>
                    setCasLog((prev) => ({
                      ...prev,
                      location: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="grid grid-cols-2   ">
                <div className="flex space-x-1 ">
                  <MdOutlineCategory className="w-4 h-4" />
                  <span>Category</span>
                </div>

                <select
                  value={category}
                  className="bg-secondary px-1 rounded py-1"
                  onChange={(e) =>
                    setCasLog((prev) => ({
                      ...prev,
                      category: e.target.value,
                    }))
                  }
                >
                  {categories.map((type) => (
                    <option key={type.name} value={type.name}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="grid grid-cols-2   ">
                <div className="flex space-x-1 ">
                  <MdMap className="w-4 h-4" />
                  <span>Zone</span>
                </div>
                <select
                  value={zone}
                  className="bg-secondary px-1 rounded py-1"
                  onChange={(e) =>
                    setCasLog((prev) => ({ ...prev, zone: e.target.value }))
                  }
                >
                  {locations.map((type) => (
                    <option key={type.name} value={type.name}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>
            </Card>

            <Card title={"Financial"}>
              <div className="grid grid-cols-2     ">
                <div className="flex space-x-1 ">
                  <FaDollarSign className="w-4 h-4" />
                  <span>Loss</span>
                </div>

                <input
                  type="number"
                  className="bg-secondary px-1 py-1 rounded outline-none  "
                  placeholder="Amount"
                  value={loss}
                  onChange={(e) =>
                    setCasLog((prev) => ({ ...prev, loss: e.target.value }))
                  }
                />
              </div>

              <div className="grid grid-cols-2   ">
                <div className="flex space-x-1 ">
                  <MdRotate90DegreesCcw className="w-4 h-4" />
                  <span>Recovery</span>
                </div>
                <input
                  value={recovery}
                  type="number"
                  className="bg-secondary px-1 py-1 rounded outline-none "
                  placeholder="Amount"
                  onChange={(e) =>
                    setCasLog((prev) => ({ ...prev, recovery: e.target.value }))
                  }
                />
              </div>
            </Card>

            <Card title={"Status"}>
              <div className="flex items-center justify-center">
                <select
                  value={status}
                  onChange={(e) =>
                    setCasLog((prev) => ({ ...prev, status: e.target.value }))
                  }
                  className=" bg-header hover:bg-header/70 py-1  rounded px-2 outline-none"
                >
                  <option value={"Open"}>{"Open"}</option>
                  <option value={"Under Investigation"}>
                    {"Under Investigation"}
                  </option>
                  <option value={"On Hold"}>{"On Hold"}</option>
                  <option value={"Closed"}>{"Closed"}</option>
                </select>
              </div>
            </Card>
            <UploadButton
              caseNumber={caseNumber}
              caseId={id}
              setCaseFiles={setCaseFiles}
              caseFiles={caseFiles}
              uploadFiles={uploadFiles}
              setSelectedFiles={setSelectedFiles}
            />
          </div>

          <div className="flex flex-col space-y-2 mt-3 md:mt:0">
            <button
              onClick={handleSave}
              className=" px-4 py-2 bg-blue-500/70 hover:bg-blue-500 rounded mb-auto  flex items-center justify-center text-base space-x-2 transition-all duration-300 ease-out shadow-lg"
            >
              <span>Save</span>
              <MdSave />
            </button>
            <button
              onClick={() => {
                router(`/case-log`);
              }}
              className=" px-4 py-2 bg-red-500/70 hover:bg-red-500 text-white rounded mb-auto  flex items-center justify-center text-base space-x-2 transition-all duration-300 ease-out shadow-lg "
            >
              <span>Cancel</span>
              <MdCancel />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCase;
